export enum TabsEnum {
  PRODUCT = 'PRODUCT',
  DQS = 'DQS',
  EMISSIONS = 'EMISSIONS',
  IMPACTS = 'IMPACTS',
}

export const FLAG_FIELDS = [
  'l1_LandManagementCarbon',
  'l1_LandManagementNonCarbon',
  'l1_LandUseChangeCarbon',
  'l1_NonLandCarbon',
  'l0_NetCarbon',
  'l1_UnverifiedRemovalsCarbon',
  'l1_VerifiedRemovalsCarbon',
]

export enum ProductStagesEnum {
  AGGREGATED = 'aggregated',
  FARMING = 'farming',
  PACKAGING = 'packaging',
  PROCESSING = 'processing',
  STORAGE = 'storage',
  TRANSPORT = 'transport',
  SALE = 'sale',
}

export const PRODUCT_STAGES = [
  { label: 'Aggregated', value: ProductStagesEnum.AGGREGATED },
  { label: 'Farming', value: ProductStagesEnum.FARMING },
  { label: 'Packaging', value: ProductStagesEnum.PACKAGING },
  { label: 'Processing', value: ProductStagesEnum.PROCESSING },
  { label: 'Storage', value: ProductStagesEnum.STORAGE },
  { label: 'Transport', value: ProductStagesEnum.TRANSPORT },
  { label: 'Sale', value: ProductStagesEnum.SALE },
]

export const IMPACT_STAGES = [
  ProductStagesEnum.AGGREGATED,
  ProductStagesEnum.FARMING,
  ProductStagesEnum.PACKAGING,
  ProductStagesEnum.PROCESSING,
  ProductStagesEnum.STORAGE,
  ProductStagesEnum.TRANSPORT,
  ProductStagesEnum.SALE,
]

export const IMPACTS = ['landUse', 'biodiversity', 'carbon', 'eutrophication', 'waterUsage']

export const DQS_FIELDS = [
  'overall',
  'time',
  'geography',
  'reliability',
  'completeness',
  'techSystem',
  'techCrop',
  'siteEnergy',
]

const IMPACT_FIELDS = IMPACTS.reduce((acc, impact) => {
  IMPACT_STAGES.forEach(stage => {
    acc.push(`${stage}.${impact}`)
  })
  return acc
}, [] as string[])

export const TAB_LABELS = {
  [TabsEnum.PRODUCT]: 'Product info',
  [TabsEnum.DQS]: 'DQS',
  [TabsEnum.EMISSIONS]: 'GHG Emissions',
  [TabsEnum.IMPACTS]: 'Impacts',
}

export const TAB_ERRORS = {
  [TabsEnum.PRODUCT]: [
    'productType',
    'productId',
    'productionSystem',
    'name',
    'productGroupId',
    'productCategoryId',
  ],
  [TabsEnum.DQS]: DQS_FIELDS.map(field => `dqs.${field}`),
  [TabsEnum.EMISSIONS]: FLAG_FIELDS.map(field => `flag.${field}`),
  [TabsEnum.IMPACTS]: IMPACT_FIELDS,
}
